import { render, staticRenderFns } from "./EssCompensatoryLeavesEmployeeLeaveDetails.vue?vue&type=template&id=fe1158a0"
import script from "./EssCompensatoryLeavesEmployeeLeaveDetails.vue?vue&type=script&lang=js"
export * from "./EssCompensatoryLeavesEmployeeLeaveDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports